export default __webpack_public_path__ + "static/media/conteudo01.ac0d8e5a.png";